import React from 'react';

import WpayPaymentAuthReturnComp from '@ecp/common/src/components/interface/WpayPaymentAuthReturnComp';

import { useAlertDialog } from '@mo-hooks/common/useModal';
import wpayApi from '@mo-apis/interface/wpayApi';

const WpayPaymentAuthReturn = () => {
  const { showAlertDialog } = useAlertDialog();

  // [WIP-32635] 반환 전용 컴포넌트가 성공 시 주문창을 완료 화면으로 보내고, 실패 시 안내 후 팝업을 닫습니다.
  return <WpayPaymentAuthReturnComp showAlertDialog={showAlertDialog} wpayApi={wpayApi} />;
};

export default WpayPaymentAuthReturn;
